export const WaitingCriteriaOptions: { label: string; value: string }[] = [
   {
      label: 'Time Period',
      value: 'Time Period',
   },
   {
      label: 'Tag',
      value: 'Tag',
   },
   {
      label: 'Stage',
      value: 'Stage',
   },
]